export const AUTH_PATHS = {
  callback: '/callback',
  signIn: '/sign-in',
  forgotPassword: '/forgot-password',
  logOut: '/logout',
} as const
